import styled from "styled-components";

export const SectionWrapper = styled.div`
  display: grid;
  grid-gap: 0.2em;
  font-family: ${({ theme }) => theme.secondaryFontFamilyTwo};

  input {
    padding: 0.5em;
    width: 100%;
    height: 40px;
    border: 1px solid ${({ theme }) => theme.secondaryGrayLightOne};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input:focus {
    border-color: ${({ theme }) => theme.secondaryPinkLightOne};
    box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.secondaryPinkLightOne};
  }

  input::placeholder {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.secondaryGrayDarkOne};
  }

  label {
    font-weight: 400;
    font-size: 12px;
  }
`;
